import WazeWikiBadge from "../../components/waze-wiki-badge";

<template>
  {{#if @outletArgs.model.postStream.posts.[0].wiki}}
    <WazeWikiBadge class="wiki-badge-topic-above-post-stream" />
  {{/if}}
</template>
